export const SUPPORTED_LOCALES = ["uz", "ru", "en"] as const

export type AppLocale = typeof SUPPORTED_LOCALES[number]

/** Uzbek is the product's primary language; Russian is the fallback chain. */
export const DEFAULT_LOCALE: AppLocale = "uz"
export const FALLBACK_LOCALE: AppLocale = "ru"

/** BCP 47 tags for `Intl` — the app's own codes are the short forms. */
export const INTL_LOCALES: Record<AppLocale, string> = {
  uz: "uz-UZ",
  ru: "ru-RU",
  en: "en-US",
}

const STORAGE_KEY = "safy.admin.locale"

export function isAppLocale(value: unknown): value is AppLocale {
  return typeof value === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

/**
 * The persisted choice, else the default. Browser detection is deliberately not
 * used — the product's primary language is Uzbek and landing does the same, so a
 * Russian-configured browser must not silently flip the panel on first visit.
 * Storage can throw in private-mode Safari, so the access is guarded.
 */
export function resolveInitialLocale(): AppLocale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (isAppLocale(stored))
      return stored
  } catch {}

  return DEFAULT_LOCALE
}

export function storeLocale(locale: AppLocale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {}
}
